<template>
  <div class="slide-captcha">
    <div class="captcha-container" v-if="backgroundImage && tileImage">
      <!-- 背景图片 -->
      <div class="background-container">
        <img
          :src="backgroundImage"
          alt="验证码背景"
          class="background-image"
          @load="onImageLoad"
        />
        <img
          :src="tileImage"
          alt="滑块"
          class="tile-image"
          :style="tileStyle"
          ref="tileRef"
        />
      </div>
      <!-- 滑动轨道 -->
      <div class="slider-track">
        <div
          class="slider-progress"
          :style="{ width: sliderProgress + 'px' }"
        ></div>
        <div
          class="sliderButton"
          :style="{ left: sliderProgress + 'px' }"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <LoadingOutlined v-if="verifyLoading" />

          <ArrowRightOutlined v-else />
        </div>
        <span class="slider-text" v-if="sliderProgress == 0">
          向右滑动完成验证
        </span>
      </div>
    </div>
    <!-- 加载状态 -->
    <div v-else class="loading-container">
      <div class="loading-spinner"></div>
      <p>正在加载验证码...</p>
    </div>

    <!-- 控制按钮 -->
    <div class="control-buttons">
      <button
        @click="getCaptcha"
        :disabled="captchaLoading"
        class="refresh-btn"
      >
        刷新验证码
      </button>
    </div>
  </div>
</template>

<script>
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons-vue";
export default {
  components: {
    ArrowRightOutlined,
    LoadingOutlined,
  },
  name: "slideCaptcha",
  data() {
    return {
      // 校验资源
      backgroundImage: null,
      tileImage: null,
      captchaId: null,
      captchaLoading: false,

      isDragging: false,
      startX: 0,

      sliderProgress: 0,
      tileX: 0,
      tileY: 0,
      verifyLoading: false,
    };
  },
  props: {
    mobile: {
      type: String,
      default: "",
    },
    mould: {
      type: Number,
      // 2  "注册登录获取短信验证码"
      // 3  "修改密码获取短信验证码"
      default: 2,
    },
  },
  computed: {
    tileStyle() {
      return {
        left: this.tileX + "px",
        top: this.tileY + "px",
      };
    },
  },
  mounted() {
    this.getCaptcha();

    document.addEventListener("mousemove", this.onDrag);
    document.addEventListener("mouseup", this.endDrag);
    document.addEventListener("touchmove", this.onDrag, { passive: false });
    document.addEventListener("touchend", this.endDrag);
  },
  beforeUnmount() {
    document.removeEventListener("mousemove", this.onDrag);
    document.removeEventListener("mouseup", this.endDrag);
    document.removeEventListener("touchmove", this.onDrag);
    document.removeEventListener("touchend", this.endDrag);
  },
  methods: {
    // 请求验证图
    getCaptcha() {
      this.captchaLoading = true;
      this.$http
        .GET(this.$manageUrl.getVerifycode, {})
        .then((res) => {
          if (res) {
            console.log(res);
            this.backgroundImage = res.result.master_image;
            this.tileImage = res.result.tile_image;
            this.captchaId = res.result.code_id;
            this.tileY = res.result.y || 0;

            // 重置滑块
            this.sliderProgress = 0;
            this.tileX = 0;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error(error.msg || error.message || "ERROR");
        })
        .finally(() => {
          this.captchaLoading = false;
        });
    },
    // 开始拖拽
    startDrag(e) {
      if (this.captchaLoading) return;

      this.isDragging = true;
      this.startX = e.type === "mousedown" ? e.clientX : e.touches[0].clientX;

      document.body.style.userSelect = "none";
    },
    // 拖拽
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();

      const currentX =
        e.type === "mousemove" ? e.clientX : e.touches[0].clientX;
      const deltaX = currentX - this.startX;

      this.sliderProgress = Math.max(0, Math.min(250, deltaX));
      this.tileX = this.sliderProgress;
    },
    // 拖拽结束
    endDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;
      document.body.style.userSelect = "";

      // 验证滑块位置
      this.verifyCaptcha();
    },
    // 执行验证
    verifyCaptcha() {
      this.verifyLoading = true;
      this.$http
        .POST(this.$manageUrl.getsmscode, {
          mobile: this.mobile,
          mould: this.mould,
          code_id: this.captchaId,
          x: Math.floor(this.tileX),
          y: this.tileY,
        })
        .then((res) => {
          if (res) {
            console.log(res);
            this.$message.success(res.msg);
            this.$emit("slideCaptchaCall");
          }
        })
        .catch((error) => {
          // 失败一次就废弃
          this.getCaptcha();
          console.log(error);
          this.$message.error(error.msg || error.message || "ERROR");
        })
        .finally(() => {
          this.verifyLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-captcha {
  max-width: 300px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.captcha-container {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: #f9f9f9;
  // 图片
  .background-container {
    position: relative;
    width: 300px;
    height: 220px;
    .background-image {
      width: 100%;
      height: 100%;
      display: block;
    }
    .tile-image {
      position: absolute;
      width: 60px;
      height: 60px;
      cursor: pointer;
      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
    }
  }
  // 滑块
  .slider-track {
    position: relative;
    height: 50px;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .slider-progress {
      height: 100%;
      background: linear-gradient(to right, #4caf50, #45a049);
    }
    .sliderButton {
      position: absolute;
      width: 50px;
      height: 50px;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: grab;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }
      &:active {
        cursor: grabbing;
      }
    }
    .slider-text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #999;
      font-size: 14px;
      pointer-events: none;
      user-select: none;
    }
  }
}
// 没有图的时候
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 270px;
  color: #666;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f0f0f0;
    border-top: 4px solid #4caf50;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
  }
}
// 按钮
.control-buttons {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  justify-content: center;
  .refresh-btn {
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      background: #f5f5f5;
      border-color: #999;
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>